
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.69 9.69a1.103 1.103 0 01-.796-.34L.998 2.18a1.1 1.1 0 01-.308-.765A1.103 1.103 0 012.589.649l6.1 6.345L14.792.65a1.103 1.103 0 111.59 1.53L9.486 9.35a1.103 1.103 0 01-.795.339"}})])
          )
        }
      }
    